import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface TextFieldProps<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  label: string;
  type?: string;
  placeholder?: string;
  error?: string;
}

export function TextField<T extends FieldValues>({
  control,
  name,
  label,
  type = 'text',
  placeholder,
  error,
}: TextFieldProps<T>) {
  return (
    <div className="space-y-3">
      <Label className="text-base font-semibold text-brand-dark">{label}</Label>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Input
            {...field}
            type={type}
            placeholder={placeholder}
            className={`rounded-lg ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500/20' : ''}`}
          />
        )}
      />
      {error && <p className="text-sm text-red-600 mt-2 font-medium">{error}</p>}
    </div>
  );
}